import { useContext } from 'react';

import { DebtConContext } from '@src/app/contexts/DebtCon';
import EligibilityLayout from '@src/ui/layouts/EligibilityLayout';
import MainGoalView from '@src/ui/views/debtCon/MainGoalView';

const MainGoal = () => {
    const { loading } = useContext(DebtConContext);

    return (
        <EligibilityLayout loading={loading}>
            <MainGoalView />
        </EligibilityLayout>
    );
};

export default MainGoal;
